/* eslint-disable react-hooks/exhaustive-deps */
// NormalSearch.js
import React, { useEffect, useState } from "react";
import {
  getConvertFunction,
  formatDate,
  getDateInputType,
  selectAllFirstOptions,
} from "./helpers/helpers";
import { optionsConfig } from "./constants/constants";
import MultiSelectDropdown from "./MultiSelectDropdown";
import { useAuctionDetail } from "../../components/common/AunctioneerDeteailProvider";
import axiosMain from "../../http/axios/axios_main";

const NormalSearch = ({
  searchColumnDetails,
  getDataRequest,
  hasAdvancedSearchColumnDetails,
  setIsSearchPopupOpen,
  isSearchPopupOpen,
  hideButtons,
  setCurrentPage
}) => {
  const [multiselectValues, setMultiselectValues] = useState({});
  const [isErrorMessageOpen, setIsErrorMessageOpen] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [selectedComboValues, setSelectedComboValues] = useState({});
  const [extraSelectData, setExtraSelectData] = useState([]);
  const [dateTypes, setDateTypes] = useState({});
  const [fetchedData, setFetchedData] = useState([]);
  const { auctionCenterId } = useAuctionDetail();

  useEffect(() => {
    if (searchColumnDetails.length) {
      selectAllFirstOptions(
        searchColumnDetails,
        handleComboChange,
        setDateTypes
      );
    }
  }, [searchColumnDetails]);

  const handleComboChange = (e, columnDetail) => {
    if (isErrorMessageOpen) setIsErrorMessageOpen(false);
    const { value } = e.target;
    const extractedValue =
      value.split("=").length > 1 ? value.split("=")[1] : value;
    const isNumeric = !isNaN(extractedValue);

    setSelectedComboValues((prevComboValues) => ({
      ...prevComboValues,
      [columnDetail.selectFieldName]:
        value === ""
          ? ""
          : columnDetail.searchCriteria === 0
            ? `${columnDetail.selectFieldName} LIKE '%${extractedValue}%'`
            : `${columnDetail.selectFieldName} = ${isNumeric ? parseInt(extractedValue, 10) : `'${extractedValue}'`
            }`,
    }));
  };

  const handleFormSubmit = async () => {

    setCurrentPage(1)
    let combinedConditions = [];

    const fieldData = searchColumnDetails.filter(
      (ele) => ele.datatype === "Date"
    )[0];

    Object.keys(dateTypes).forEach((fieldName) => {
      const dateCriteria = getConvertFunction(
        inputValues,
        fieldData,
        dateTypes[fieldName]
      );
      combinedConditions.push(dateCriteria['dateTime']);
    });

    Object.keys(selectedComboValues).forEach((key) => {
      if (selectedComboValues[key]) {
        combinedConditions.push(selectedComboValues[key]);
      }
    });

    Object.keys(multiselectValues).forEach((fieldName) => {
      const selectedItems = multiselectValues[fieldName];
      if (selectedItems && selectedItems.length) {
        const condition = `${fieldName} IN (${selectedItems
          .map((item) => item.value)
          .join(",")})`;
        combinedConditions.push(condition);
      }
    });

    const finalQuery = combinedConditions.filter(Boolean).join(" AND ");

    // if (finalQuery) {
      try {
        const response = await getDataRequest(finalQuery);
        setFetchedData(response.data);
        
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsErrorMessageOpen(true);
      }
    // } 
    // else {
    //   setIsErrorMessageOpen(true);
    // }
  };

  const handleInputChange = (e, selectFieldName, inputType) => {
    if (isErrorMessageOpen) setIsErrorMessageOpen(false);
    const { value } = e.target;

    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [selectFieldName]:
        inputType === "date" && value ? formatDate(value) : value,
    }));
  };

  const handleFormReset = () => {
    if (isErrorMessageOpen) setIsErrorMessageOpen(false);
    setCurrentPage(1);
    setExtraSelectData([]);
    setSelectedComboValues({});
    setInputValues({});
    setMultiselectValues({});
    setDateTypes((dateTypes) => {
      const result = {};
      Object.keys(dateTypes).forEach((dateTypeKey) => {
        result[dateTypeKey] = optionsConfig.equal.value;
      });
      return result;
    });
    selectAllFirstOptions(searchColumnDetails, handleComboChange, setDateTypes);
    const resetableElements = document.querySelectorAll("[data='resetable']");
    [].forEach.call(resetableElements, (element) => {
      element.value = "";
    });
  };

  return (
    <div
      style={{
        display:
          !hasAdvancedSearchColumnDetails || isSearchPopupOpen
            ? "block"
            : "none",
      }}
    >
      <div className="row">
        {searchColumnDetails?.map((columnDetail) => {
          const fieldArray =
            columnDetail?.tblReportControlMaster?.[0]?.responseField?.split(
              ":"
            );
          const labelOptionName = Array.isArray(fieldArray)
            ? fieldArray[fieldArray.length - 1]
            : "";
          const valueOptionName = Array.isArray(fieldArray)
            ? fieldArray[0]
            : "";
          return (
            <div key={columnDetail.columnId} className="col-xl-2">
              <label>{columnDetail.columnName}</label>
              {columnDetail.tblReportControlMaster[0].controlType ===
                "combo" ? (
                <select
                  className="form-control select-form"
                  data="resetable"
                  onChange={(e) => handleComboChange(e, columnDetail)}
                  // value={
                  //   selectedComboValues[columnDetail.selectFieldName] || ""
                  // }
                  value={
                    !columnDetail.tblReportControlMaster[0].isAPI &&
                      columnDetail.tblReportControlMaster[0].tblReportControlDetail?.some(
                        (option) => option.isDefaultSelected === "Y"
                      )
                      ? selectedComboValues[columnDetail.selectFieldName]
                      : undefined
                  }
                >
                  <option value={""}>{columnDetail.tblReportControlMaster[0].isDefaultAll === 1 ? "ALL" : "Select Value"}</option>
                  {columnDetail.tblReportControlMaster[0].isAPI
                    ? (
                      extraSelectData[
                        columnDetail.tblReportControlMaster[0].apiname
                      ]?.options || []
                    ).map((optionData) => {
                      const value = `${valueOptionName}=${optionData[valueOptionName]}`;
                      const label = `${optionData[labelOptionName]}`;
                      return (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      );
                    })
                    : columnDetail.tblReportControlMaster[0].tblReportControlDetail?.map(
                      (controlDetail) => (
                        <option
                          key={controlDetail.reportControlDetailId}
                          value={controlDetail.controlValue}
                        >
                          {controlDetail.lang1 || controlDetail.condition}
                        </option>
                      )
                    )}
                </select>
              ) : columnDetail.tblReportControlMaster[0].controlType ===
                "date" ||
                columnDetail.tblReportControlMaster[0].controlType ===
                "datetime" ? (
                <>
                  <select
                    className="form-control select-form"
                    value={
                      dateTypes[columnDetail.selectFieldName] ||
                      optionsConfig.equal.value
                    }
                    onChange={(e) => {
                      if (isErrorMessageOpen) setIsErrorMessageOpen(false);
                      setDateTypes({
                        [columnDetail.selectFieldName]: e.target.value,
                      });
                    }}
                  >
                    {Object.values(optionsConfig).map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <input
                    className="form-control"
                    data="resetable"
                    type={getDateInputType(
                      columnDetail.tblReportControlMaster[0].controlType
                    )}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        columnDetail.selectFieldName + "From",
                        getDateInputType(
                          columnDetail.tblReportControlMaster[0].controlType
                        )
                      )
                    }
                  />
                  {dateTypes[columnDetail.selectFieldName] ===
                    optionsConfig.between.value && (
                      <input
                        className="form-control asd"
                        data="resetable"
                        type={getDateInputType(
                          columnDetail.tblReportControlMaster[0].controlType
                        )}
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            columnDetail.selectFieldName + "To",
                            getDateInputType(
                              columnDetail.tblReportControlMaster[0].controlType
                            )
                          )
                        }
                      />
                    )}
                </>
              ) : (
                <input
                  className="form-control"
                  data="resetable"
                  onChange={(e) =>
                    handleInputChange(e, columnDetail.selectFieldName)
                  }
                />
              )}
            </div>
          );
        })}
      </div>

      {
        !hideButtons && (
          <div className="BtnGroup mb-3">
            <button className="SubmitBtn" onClick={handleFormSubmit}>
              Search
            </button>
            <button className="SubmitBtn" onClick={handleFormReset}>
              Clear
            </button>
            {isSearchPopupOpen && (
              <button
                className="SubmitBtn"
                onClick={() => setIsSearchPopupOpen(false)}
              >
                -
              </button>
            )}
          </div>
      )
      }
      {/* Display fetched data */}
      <div className="col-12">
        {fetchedData.length > 0 && (
          <table className="table">
            <thead>
              <tr>
                {/* Adjust headers based on your data structure */}
                <th>ID</th>
                <th>Name</th>
                <th>Date</th>
                {/* Add more headers as necessary */}
              </tr>
            </thead>
            <tbody>
              {fetchedData.map((item, index) => (
                <tr key={index}>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.date}</td>
                  {/* Map more fields as necessary */}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* <div className="col-12 p-0">
        {isErrorMessageOpen && (
          <p style={{ color: "red" }}>Please select at least one value</p>
        )}
      </div> */}
    </div>
  );
};

export default NormalSearch;
